import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { LocalStorageService } from 'bcte-common-lib';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private storageService = inject(LocalStorageService);

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Get the JWT token from localStorage or your authentication service
    const jwtToken = this.storageService.getItem('user');

    // If a token exists, add it to the Authorization header
    if (jwtToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwtToken}`
        }
      });
    }

    return next.handle(request);
  }
}
